module.exports = "<div #imageWrapper (dragover)=\"allowDrop($event)\"\r\n     (drop)=\"drop($event, item)\"\r\n     [id]=\"'imageWrapper' + item\"\r\n     [ngClass]=\"arrShowStatus[item] ? 'status-ready' : 'status-empty' \" class=\"imageWrapper\"\r\n     data-status=\"empty\" data-type=\"image\"\r\n     href=\"javascript:void(0)\" style=\"position: relative;\">\r\n    <ng-content></ng-content>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/image-upload/image-upload.component.html
// module id = ./src/app/commons/image-upload/image-upload.component.html
// module chunks = main